<template>
  <div class="rayleigh-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>I ∝ 1 / λ⁴ | 为何天空是蓝色的$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Atmosphere -->
          <rect x="0" y="0" width="400" height="240" fill="#020205" />
          
          <!-- Incoming White Light (Sunlight) -->
          <g transform="translate(20, 120)">
             <line x1="0" y1="0" x2="300" y2="0" stroke="#fff" stroke-width="10" opacity="0.1" />
             <text x="0" y="-15" fill="#fff" font-size="8">入射太阳光 (全光谱)</text>
          </g>

          <!-- Scattered Blue Light Particles -->
          <g v-for="n in 30" :key="n" :transform="`translate(${40 + n*10}, 120)`">
             <circle r="2" fill="#fff" />
             <!-- Blue Rays Scattering -->
             <line x1="0" y1="0" :x2="(Math.random()-0.5)*40" :y2="(Math.random()-0.5)*40" stroke="#00d2ff" stroke-width="1" opacity="0.6">
                <animate attributeName="opacity" values="0.2;0.8;0.2" :dur="`${0.5 + Math.random()}s`" repeatCount="indefinite" />
             </line>
          </g>

          <!-- Transmitted Light (Redder) -->
          <line x1="300" y1="120" x2="400" y2="120" stroke="#ff4757" stroke-width="6" opacity="0.4" />
          <text x="320" y="140" fill="#ff4757" font-size="8">透射光 (夕阳色)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>散射强度: 蓝色 (420nm) > 红色 (700nm)</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>瑞利散射描述了光被比光波长小得多的颗粒（如空气中的氧、氮分子）散射的现象。由于蓝光的波长较短，其**散射强度**约为红光的10倍。这就是为什么白天天空看起来是蓝色的。而在日出或日落时，阳光在大气中路程很长，蓝光几乎被散射殆尽，留下的**直射光**以红黄色为主，形成了绚丽的夕阳。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'RayleighScatteringViz'
}
</script>

<style scoped lang="scss">
.rayleigh-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
